import { Component, inject, output, ChangeDetectionStrategy } from '@angular/core';
import { IonAccordion, IonButton, IonItem, IonLabel } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { EmptyResultComponent, SkeletonCardInprogressComponent } from '@okcargo-apps/layout-ionic';
import { FreightCarrierStoreService } from '../freight-carrier-store.service';
import { FreightCarrierFinishedCardComponent } from '../freight-carrier-finished-card/freight-carrier-finished-card.component';

@Component({
  selector: 'lib-freight-carrier-pending-deliverynote-paper-list',
  templateUrl: './freight-carrier-pending-deliverynote-paper-list.component.html',
  styleUrls: ['./freight-carrier-pending-deliverynote-paper-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateModule,
    IonButton,
    IonItem,
    IonAccordion,
    IonLabel,
    FreightCarrierFinishedCardComponent,
    SkeletonCardInprogressComponent,
    EmptyResultComponent,
  ],
})
export class FreightCarrierPendingDeliverynotePaperListComponent {
  private readonly freightCarrierStoreService = inject(FreightCarrierStoreService);

  protected readonly vm = this.freightCarrierStoreService.freightsWithoutDeliveryNoteInPaperReceived;

  // Emitted when there are more freights than the ones rendered; the hosting page
  // owns the navigation (e.g. to the finished tab filtered by this list).
  public readonly seeMore = output<void>();
}
